// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import I18n from 'PMT/i18n/I18n';
import { CurrencyUtils } from 'PMT/utils';
import { getAllergenLabel } from 'PMT/constants/DietaryConstants';
import isEmpty from 'lodash/isEmpty';

// -- entities
import ProductOptionValue from 'PMT/entities/menu/ProductOptionValue';

class ProductOptionValueRow extends Component {
  static propTypes = {
    productOptionValue: PropTypes.objectOf(ProductOptionValue).isRequired,
    currencyCode: PropTypes.string,
  };

  shouldComponentUpdate(nextProps) {
    return !nextProps.productOptionValue.equals(this.props.productOptionValue);
  }

  // -- getters

  get productOptionValue(): ProductOptionValue {
    return this.props.productOptionValue;
  }

  get currencyCode(): string {
    return this.props.currencyCode;
  }

  get formattedPrice(): Price {
    if (this.productOptionValue.additionalPrice !== 0) {
      return `(+${CurrencyUtils.formatPriceWithCurrency(
        this.productOptionValue.additionalPrice,
          this.currencyCode
      )})`;
    }
    return '';
  }

  // -- renderers

  render() {
    return (
      <li>
        <h4>
          {this.productOptionValue.name} {this.formattedPrice}
        </h4>
        {this.productOptionValue.dietaryInfo &&
          !isEmpty(this.productOptionValue.dietaryInfo) && (
            <span>
              {I18n.tr('global.allergen.allergens')}:&nbsp;
              {this.productOptionValue.dietaryInfo.allergens.map(allergen => (
                <span>{getAllergenLabel(allergen)}</span>
              ))}
            </span>
          )}
      </li>
    );
  }
}

export default ProductOptionValueRow;



// WEBPACK FOOTER //
// ./scripts/pages/menu/option/components/ProductOptionValueRow.js